import React, { useEffect, useRef } from 'react';
import { Divider, TextField, Grid, Typography, Button, FormControl } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { RoleAddRequest } from 'src/models/roles';
import { object, string } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import BuildIcon from '@mui/icons-material/Build';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TabOne from './components/TabOne';
import TabTwo from './components/TabTwo';
import TabThree from './components/TabThree';
import TabFour from './components/TabFour';
import {
  deleteRole,
  getFieldsByType,
  getPermissionByType,
  getRoleById,
  updateRole
} from 'src/services/RoleManagementService';
import { AppActions } from 'src/store/AppReducer';
import { useDispatch } from 'react-redux';
import ConfirmationModal from 'src/content/common/confirmationModal/ConfirmationModal';
import moment from 'moment';
import { useAppSelector } from 'src/hooks/hooks';
import TabFive from './components/TabFive';
import { DatePicker } from '@mui/lab';
import TabNine from './components/TabNine';
import TabTen from './components/TabTen';
import TabEleven from '../EditForm/components/TabEleven';
import TabTwelve from '../EditForm/components/TabTwelve';
import TabThirteen from './components/TabThirteen';
import TabFourteen from '../EditForm/components/TabFourteen';
import TabFifteen from '../EditForm/components/TabFifteen';

const ATTENDANCE_PERMISSIONS = new Set([
  'view employee attendance',
  'import attendance',
  'download attendance report',
  'view employee mapping',
  'add employee mapping',
  'edit employee mapping',
  'remove employee mapping',
  'my attendance',
  'employee attendance'
]);

const isAttendancePermission = (item) =>
  ATTENDANCE_PERMISSIONS.has(String(item?.name || '').trim().toLowerCase());

const EditForm = ({
  LabelStyle,
  TextFieldStyle,
  onClose,
  data,
  getData,
  visibility
}) => {
  const dispatch = useDispatch();
  const [tabvalue, setTabValue] = useState('one');
  const [isEdit, setIsEdit] = useState(visibility);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const toggleDelete = () => {
    setDeleteOpen(!deleteOpen);
  };

  const addRoleSchema = object({
    roleName: string()
      .trim()
      .min(1, { message: 'Role name is required' })
      .max(30, 'Name must be less than 30 characters'),
    startDate: string().nonempty('Start Date is required'),
    endDate: string().optional()
  });

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm<RoleAddRequest>({
    resolver: zodResolver(addRoleSchema) as any
  });

  const handleClose = () => {
    onClose();
    reset();
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const { isLoading } = useAppSelector((state) => state.appReducer);
  const [dashboardData, setdashboardData] = useState([]);
  const [commonPermissions, setcommonPermissions] = useState([]);
  const [skillsData, setSkillsData] = useState([]);
  const [segmentData, setSegmentData] = useState([]);
  const [resourceManagementData, setResourceManagementData] = useState([]);
  const [feedbackData, setFeedbackData] = useState([]);
  const [eventManagementData, setEventManagementData] = useState([]);
  const [employeeOnboardingData, setEmployeeOnboardingData] = useState([]);
  const [onboardingToDoListData, setOnboardingToDoListData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [projectHealthData, setProjectHealthData] = useState([]);
  const [generalDetails, setgeneralDetails] = useState([]);
  const [contactDetails, setcontactDetails] = useState([]);
  const [employementDetails, setEmployementDetails] = useState([]);
  const [bankingDetails, setBankingDetails] = useState([]);
  const [commonPermissionsProject, setcommonPermissionsProject] = useState([]);
  const [generalDetailsProject, setgeneralDetailsProject] = useState([]);
  const [FinancialDetails, setFinancialDetails] = useState([]);
  const [timeEstimations, setTimeEstimations] = useState([]);
  const [stakeholders, setStakeholders] = useState([]);
  const [adminConfig, setadminConfig] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [defineLeavesData, setDefineLeavesData] = useState([]);
  const [stakeholderData, setStakeholderData] = useState([]);
  const [fieldsGetDone, setfieldsGetDone] = useState(false);
  const [dateError, setDateError] = useState('');
  const [leaveManagementData, setLeaveManagementData] = useState([]);
  const [workModelData, setWorkModelData] = useState([]);
  const [timesheetData, setTimesheetData] = useState([]);
  const [taskAssignmentData, setTaskAssignmentData] = useState([]);
  const [timeEntryData, setTimeEntryData] = useState([]);
  const [detailReportData, setDetailReportData] = useState([]);
  const [summarizedReportData, setSummarizedReportData] = useState([]);
  const [taskBasedReportData, setTaskBasedReportData] = useState([]);
  const [workFromHomeData, setWorkFromHomeData] = useState([]);
  const [resourcePoolData, setResourcePoolData] = useState([]);
  const [yearPlanData, setYearPlanData] = useState([]);
  const [carryForwardedLeavesData, setCarryForwardedLeavesData] = useState([]);
  const [employeeTimesheetData, setEmployeeTimesheetData] = useState([]);
  const [others, setOthers] = useState([]);
  const [othersEdit, setOthersEdit] = useState([]);
  const [isStartDateError, setIsStartDateError] = useState<boolean>(true);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [varianceReport, setVarianceReport] = useState([]);
  const [designationData, setDesignationData] = useState([]);

  useEffect(() => {
    if (
      !commonPermissions?.filter((comm) => comm?.name === 'Edit')[0]?.value &&
      generalDetails.length > 0 &&
      contactDetails.length > 0 &&
      bankingDetails.length > 0 &&
      employementDetails.length > 0
    ) {
      onClickAll(generalDetails, 'edit', setgeneralDetails, false);
      onClickAll(contactDetails, 'edit', setcontactDetails, false);
      onClickAll(bankingDetails, 'edit', setBankingDetails, false);
      onClickAll(employementDetails, 'edit', setEmployementDetails, false);
    }
  }, [commonPermissions]);

  useEffect(() => {
    if (
      !commonPermissionsProject?.filter((comm) => comm?.name === 'Edit')[0]
        ?.value &&
      generalDetailsProject.length > 0 &&
      stakeholders.length > 0 &&
      FinancialDetails.length > 0 &&
      timeEstimations.length > 0
    ) {
      onClickAll(
        generalDetailsProject,
        'edit',
        setgeneralDetailsProject,
        false
      );
      onClickAll(stakeholders, 'edit', setStakeholders, false);
      onClickAll(FinancialDetails, 'edit', setFinancialDetails, false);
      onClickAll(timeEstimations, 'edit', setTimeEstimations, false);
    }
  }, [commonPermissionsProject]);

  const getFields = () => {
    getFieldsByType('Dashboard').then((res) => {
      setdashboardData(res.data);
    });
    getFieldsByType('Employee').then((res) => {
      const data = res.data;
      const generalDetailsFilter = data.filter(
        (ele) => ele.category === 'General'
      );
      const contactDetailsFilter = data.filter(
        (ele) => ele.category === 'Contact'
      );
      const EmployementDetailsFilter = data.filter(
        (ele) => ele.category === 'Employment'
      );
      const BankingDetailsFilter = data.filter(
        (ele) => ele.category === 'Finance'
      );

      setgeneralDetails(generalDetailsFilter);
      setcontactDetails(contactDetailsFilter);
      setEmployementDetails(EmployementDetailsFilter);
      setBankingDetails(BankingDetailsFilter);
    });
    getFieldsByType('Project').then((res) => {
      const data = res.data;

      const generalDetailsFilter = data.filter(
        (ele) => ele.category === 'General'
      );
      const financialDetailsFilter = data.filter(
        (ele) => ele.category === 'Financial'
      );
      const TimeEstimationsFilter = data.filter(
        (ele) => ele.category === 'Time Estimation'
      );
      const StakeholdersFilter = data.filter(
        (ele) => ele.category === 'Stakeholders'
      );
      setgeneralDetailsProject(generalDetailsFilter);
      setFinancialDetails(financialDetailsFilter);
      setTimeEstimations(TimeEstimationsFilter);
      setStakeholders(StakeholdersFilter);
    });
    getPermissionByType('Employee').then((res) => {
      setcommonPermissions(res.data);
    });
    getPermissionByType('Project').then((res) => {
      setcommonPermissionsProject(res.data);
    });
    getPermissionByType('Skills').then((res) => {
      setSkillsData(res.data);
    });
    getPermissionByType('Configurations').then((res) => {
      setadminConfig(res.data);
    });
    //new name is client, but permission is Customer
    getPermissionByType('Customer').then((res) => {
      setCustomerData(res.data);
    });
    getPermissionByType('Stakeholder').then((res) => {
      setStakeholderData(res.data);
    });
    getPermissionByType('Segments').then((res) => {
      setSegmentData(res.data);
    });
    getPermissionByType('Project Health Summary').then((res) => {
      setProjectHealthData(res.data);
    });
    getPermissionByType('Resource Management').then((res) => {
      setResourceManagementData(res.data);
      setfieldsGetDone(true);
    });

    getPermissionByType('Feedback').then((res) => {
      setFeedbackData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Event Management').then((res) => {
      setEventManagementData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Employee Onboarding').then((res) => {
      setEmployeeOnboardingData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Onboarding To Do List').then((res) => {
      setOnboardingToDoListData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Attendance').then((res) => {
      const permissions = (Array.isArray(res?.data) ? res.data : []).filter(
        (item) =>
          !['my attendance', 'employee attendance'].includes(
            String(item?.name || '').trim().toLowerCase()
          )
      );
      const defaults = [
        {
          id: 'view-employee-attendance',
          name: 'View Employee Attendance',
          tab: 'Attendance',
          value: false
        },
        { id: 'import-attendance', name: 'Import Attendance', tab: 'Attendance', value: false },
        {
          id: 'download-attendance-report',
          name: 'Download Attendance Report',
          tab: 'Attendance',
          value: false
        },
        {
          id: 'c9e9e617-8ab1-42d8-bd87-9c0e76a18688',
          name: 'View Employee Mapping',
          tab: 'Attendance',
          value: false
        },
        {
          id: 'd062e9b0-0fbd-4384-b748-a12bad3d7470',
          name: 'Add Employee Mapping',
          tab: 'Attendance',
          value: false
        },
        {
          id: '44b69280-7650-4355-8c00-2e13a3e17c8c',
          name: 'Edit Employee Mapping',
          tab: 'Attendance',
          value: false
        },
        {
          id: 'c63ff77a-ad1b-477c-8516-46ff14678669',
          name: 'Remove Employee Mapping',
          tab: 'Attendance',
          value: false
        }
      ];
      const names = new Set(
        permissions.map((item) => String(item?.name || '').trim().toLowerCase())
      );
      setAttendanceData([
        ...permissions,
        ...defaults.filter((item) => !names.has(item.name.toLowerCase()))
      ]);
      setfieldsGetDone(true);
    });
    getPermissionByType('Define Leaves').then((res) => {
      setDefineLeavesData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Leave Management').then((res) => {
      setLeaveManagementData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Work Model').then((res) => {
      setWorkModelData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Activity Management').then((res) => {
      setTimesheetData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Task Assignment').then((res) => {
      setTaskAssignmentData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Time Entry').then((res) => {
      setTimeEntryData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Detailed Report').then((res) => {
      setDetailReportData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Summarized Report').then((res) => {
      setSummarizedReportData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Task Based Report').then((res) => {
      setTaskBasedReportData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Work From Home').then((res) => {
      setWorkFromHomeData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Year Plan').then((res) => {
      setYearPlanData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Carry Forwarded Leaves').then((res) => {
      setCarryForwardedLeavesData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Resource Pool').then((res) => {
      setResourcePoolData(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Variance Report').then((res) => {
      setVarianceReport(res.data);
      setfieldsGetDone(true);
    });
    getPermissionByType('Employee Timesheet').then((res) => {
      setEmployeeTimesheetData(res.data);
    });
    getPermissionByType('Designations').then((res) => {
      setDesignationData(res.data);
      setfieldsGetDone(true);
    });
  };

  useEffect(() => {
    getFields();
  }, []);

  const [roleById, setRoleById] = useState<any>({});
  const attendanceAppliedRoleId = useRef(null);

  useEffect(() => {
    if (data?.roleId && fieldsGetDone) {
      getRoleById(data?.roleId).then((res) => {
        setRoleById(res.data);
      });
    }
  }, [data, fieldsGetDone]);

  useEffect(() => {
    const roleId = roleById?.roleId || roleById?.id;
    if (!roleId || attendanceAppliedRoleId.current === roleId || !attendanceData.length) {
      return;
    }
    const saved = (roleById?.tabs || [])
      .filter((tab) => tab?.name === 'Attendance')
      .flatMap((tab) => tab?.permissions || [])
      .filter(
        (item) =>
          !['my attendance', 'employee attendance'].includes(
            String(item?.name || '').trim().toLowerCase()
          )
      );
    if (!saved.length) {
      attendanceAppliedRoleId.current = roleId;
      return;
    }
    const savedNames = new Set(
      saved.map((item) => String(item?.name || '').trim().toLowerCase())
    );
    const extras = attendanceData.filter(
      (item) => !savedNames.has(String(item?.name || '').trim().toLowerCase())
    );
    attendanceAppliedRoleId.current = roleId;
    setAttendanceData([...saved, ...extras]);
  }, [roleById, attendanceData]);

  useEffect(() => {
    setrole(roleById?.name);
    setValue('endDate', moment(roleById?.endDate).format('YYYY-MM-DD'));
    setValue('startDate', moment(roleById?.startDate).format('YYYY-MM-DD'));
    setValue('roleName', roleById?.name);
    if (roleById?.tabs?.length > 0) {
      const tabs = roleById.tabs;

      const employeeTabData = tabs.filter((tab) => tab.name === 'Employee');
      const dashboardTabData = tabs.filter((tab) => tab.name === 'Dashboard');
      const projectTabData = tabs.filter((tab) => tab.name === 'Project');
      const adminTabData = tabs.filter((tab) => tab.name === 'Configurations');
      const skillTabData = tabs.filter((tab) => tab.name === 'Skills');
      const segmentTabData = tabs.filter((tab) => tab.name === 'Segments');
      //new name is client, but permission is Customer
      const customerTabData = tabs.filter((tab) => tab.name === 'Customer');
      const stakeholderTabData = tabs.filter((tab) => tab.name === 'Stakeholder');
      const resourceManagementTabData = tabs.filter((tab) => tab.name === 'Resource Management');
      const feedbackTabData =  tabs.filter((tab) => tab.name === 'Feedback');
      const eventManagementTabData =  tabs.filter((tab) => tab.name === 'Event Management');
      const employeeOnboardingTabData =  tabs.filter((tab) => tab.name === 'Employee Onboarding');
      const onboardingToDoListTabData =  tabs.filter((tab) => tab.name === 'Onboarding To Do List');
      const attendanceTabData = tabs.filter((tab) => tab.name === 'Attendance');
      const projectHealthTabData = tabs.filter((tab) => tab.name === 'Project Health Summary');
      const defineLeaveTabData = tabs.filter((tab) => tab.name === 'Define Leaves');
      const leaveManagementTabData = tabs.filter((tab) => tab.name === 'Leave Management');
      const WorkModelTabData = tabs.filter((tab) => tab.name === 'Work Model');
      const timesheetTabData = tabs.filter((tab) => tab.name === 'Activity Management');
      const taskAssignmentTabData = tabs.filter((tab) => tab.name === 'Task Assignment');
      const timeEntryTabData = tabs.filter((tab) => tab.name === 'Time Entry');
      const detailReportTabData = tabs.filter((tab) => tab.name === 'Detailed Report');
      const summarizedReportTabData = tabs.filter((tab) => tab.name === 'Summarized Report');
      const taskBasedReportTabData = tabs.filter((tab) => tab.name === 'Task Based Report');
      const WorkFromHomeTabData = tabs.filter((tab) => tab.name === 'Work From Home');
      const resourcePoolTabData = tabs.filter((tab) => tab.name === 'Resource Pool');
      const yearPlanTabData = tabs.filter((tab) => tab.name === 'Year Plan');
      const carryForwardedLeavesTabData = tabs.filter((tab) => tab.name === 'Carry Forwarded Leaves');
      const varianceReportTabData = tabs.filter((tab) => tab.name === 'Variance Report');
      const employeeTimesheetTabData = tabs.filter((tab) => tab.name === 'Employee Timesheet');
      const designationTabData = tabs.filter((tab) => tab.name === 'Designations');
    
    
      let othersTabData: any = [];

      // Employee
      if (employeeTabData[0]?.fields.length > 0) {
        const employeeFields = employeeTabData[0]?.fields;
        const generalDetailsFilter = generalDetails?.filter((ele) =>
          employeeFields?.every((el) => ele.name !== el.name)
        );
        setgeneralDetails([
          ...employeeFields?.filter((el) => el.category === 'General'),
          ...generalDetailsFilter
        ]);
        const contactFilter = contactDetails?.filter((ele) =>
          employeeFields?.every((el) => ele.name !== el.name)
        );
        setcontactDetails([
          ...employeeFields?.filter((el) => el.category === 'Contact'),
          ...contactFilter
        ]);
        const employementFilter = employementDetails?.filter((ele) =>
          employeeFields?.every((el) => ele.name !== el.name)
        );
        setEmployementDetails([
          ...employeeFields?.filter((el) => el.category === 'Employment'),
          ...employementFilter
        ]);
        const bankingFilter = bankingDetails?.filter((ele) =>
          employeeFields?.every((el) => ele.name !== el.name)
        );
        setBankingDetails([
          ...employeeFields?.filter((el) => el.category === 'Finance'),
          ...bankingFilter
        ]);
      }
      //Employee Permissions
      if (employeeTabData[0]?.permissions.length > 0) {
        const employeePermissions = employeeTabData[0]?.permissions;
        const employeePermissionsFilter = commonPermissions?.filter((ele) =>
          employeePermissions?.every((el) => ele.name !== el.name)
        );
        setcommonPermissions([
          ...employeePermissions,
          ...employeePermissionsFilter
        ]);
      }

      // Dashboard
      if (dashboardTabData[0]?.fields.length > 0) {
        const dashboardFields = dashboardTabData[0]?.fields;
        const dashboardFilter = dashboardData?.filter((ele) =>
          dashboardFields?.every((el) => ele.name !== el.name)
        );
        setdashboardData([...dashboardFields, ...dashboardFilter]);
      }

      // Project Health Summary
      if (projectHealthData && projectHealthData.length > 0) {
        const projectHealthPermissions =
          projectHealthTabData[0]?.permissions || [];
        const projectHealthFilter = projectHealthData?.filter((ele) =>
          projectHealthPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...projectHealthPermissions,
          ...projectHealthFilter
        ];
        setProjectHealthData([
          ...projectHealthPermissions,
          ...projectHealthFilter
        ]);
      }

      // Resource Management
      if (resourceManagementData && resourceManagementData.length > 0) {
        const resourceManagementPermissions =
          resourceManagementTabData[0]?.permissions || [];
        const resourceManagementFilters = resourceManagementData?.filter(
          (ele) =>
            resourceManagementPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...resourceManagementPermissions,
          ...resourceManagementFilters
        ];
        setResourceManagementData([
          ...resourceManagementPermissions,
          ...resourceManagementFilters
        ]);
      }

      
      // Feedback
      if (feedbackData && feedbackData.length > 0) {
        const feedbackDataPermissions =
        feedbackTabData[0]?.permissions || [];
        const feedbackFilters = feedbackData?.filter(
          (ele) =>
            feedbackDataPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...feedbackDataPermissions,
          ...feedbackFilters
        ];
        setFeedbackData([
          ...feedbackDataPermissions,
          ...feedbackFilters
        ]);
      }

       if (designationData && designationData.length > 0) {
        const designationPermissions =
          designationTabData[0]?.permissions || [];
        const DesignationFilters = designationData?.filter(
          (ele) =>
            designationPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...designationPermissions,
          ...DesignationFilters
        ];
        setDesignationData([
          ...designationPermissions,
          ...DesignationFilters
        ]);
      }

      // Event Management
      if (eventManagementData && eventManagementData.length > 0) {
        const eventManagementDataPermissions =
        eventManagementTabData[0]?.permissions || [];
        const eventManagementFilters = eventManagementData?.filter(
          (ele) =>
            eventManagementDataPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...eventManagementDataPermissions,
          ...eventManagementFilters
        ];
        setEventManagementData([
          ...eventManagementDataPermissions,
          ...eventManagementFilters
        ]);
      }

      // Employee Onboarding
      if (employeeOnboardingData && employeeOnboardingData.length > 0) {
        const employeeOnboardingDataPermissions =
        employeeOnboardingTabData[0]?.permissions || [];
        const employeeOnboardingFilters = employeeOnboardingData?.filter(
          (ele) =>
            employeeOnboardingDataPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...employeeOnboardingDataPermissions,
          ...employeeOnboardingFilters
        ];
        setEmployeeOnboardingData([
          ...employeeOnboardingDataPermissions,
          ...employeeOnboardingFilters
        ]);
      }

      // Onboarding To Do List
      if (onboardingToDoListData && onboardingToDoListData.length > 0) {
        const onboardingToDoListDataPermissions =
        onboardingToDoListTabData[0]?.permissions || [];
        const onboardingToDoListFilters = onboardingToDoListData?.filter(
          (ele) =>
            onboardingToDoListDataPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...onboardingToDoListDataPermissions,
          ...onboardingToDoListFilters
        ];
        setOnboardingToDoListData([
          ...onboardingToDoListDataPermissions,
          ...onboardingToDoListFilters
        ]);
      }

      if (attendanceData && attendanceData.length > 0) {
        const attendancePermissions = (attendanceTabData[0]?.permissions || []).filter(
          (item) =>
            !['my attendance', 'employee attendance'].includes(
              String(item?.name || '').trim().toLowerCase()
            )
        );
        const attendanceFilters = attendanceData.filter(
          (ele) => attendancePermissions.every((el) => ele.name !== el.name)
        );
        setAttendanceData([...attendancePermissions, ...attendanceFilters]);
      }

      // Skills
      if (skillsData && skillsData.length > 0) {
        const skillsPermissions = skillTabData[0]?.permissions || [];
        const skillsFilter = skillsData?.filter((ele) =>
          skillsPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...skillsPermissions,
          ...skillsFilter
        ];
        setSkillsData([...skillsPermissions, ...skillsFilter]);
      }

      // Segments
      if (segmentData && segmentData.length > 0) {
        const segmentPermissions = segmentTabData[0]?.permissions || [];
        const segmentFilter = segmentData?.filter((ele) =>
          segmentPermissions?.every((el) => ele.name !== el.name)
        );

        othersTabData = [
          ...othersTabData,
          ...segmentPermissions,
          ...segmentFilter
        ];
        setSegmentData([...segmentPermissions, ...segmentFilter]);
      }

      // Admin
      if (adminConfig && adminConfig.length > 0) {
        const adminFields = adminTabData[0]?.permissions || [];
        const adminFilter = adminConfig?.filter((ele) =>
          adminFields?.every((el) => ele.name !== el.name)
        );
        othersTabData = [...othersTabData, ...adminFields, ...adminFilter];
        setadminConfig([...adminFields, ...adminFilter]);
      }

      //new name is client, but permission is Customer
      if (customerData && customerData.length > 0) {
        const customerPermissions = customerTabData[0]?.permissions || [];
        const customerFilter = customerData?.filter((ele) =>
          customerPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...customerPermissions,
          ...customerFilter
        ];
        setCustomerData([...customerPermissions, ...customerFilter]);
      }

      // Stakeholder
      if (stakeholderData && stakeholderData.length > 0) {
        const stakeholderPermissions = stakeholderTabData[0]?.permissions || [];
        const stakeholderFilter = stakeholderData?.filter((ele) =>
          stakeholderPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...stakeholderPermissions,
          ...stakeholderFilter
        ];
        setStakeholderData([...stakeholderPermissions, ...stakeholderFilter]);
      }

        // Define Leaves
        if (defineLeavesData && defineLeavesData.length > 0) {
          const defineLeavesPermissions = defineLeaveTabData[0]?.permissions || [];
          const defineLeaveFilter = defineLeavesData?.filter((ele) =>
            defineLeavesPermissions?.every((el) => ele.name !== el.name)
          );
          othersTabData = [
            ...othersTabData,
            ...defineLeavesPermissions,
            ...defineLeaveFilter
          ];
          setDefineLeavesData([...defineLeavesPermissions, ...defineLeaveFilter]);
        }


        //Leave Management
        if (leaveManagementTabData[0]?.permissions.length > 0) {
          const leavePermissions = leaveManagementTabData[0]?.permissions;
          const leavePermissionsFilter = leaveManagementData?.filter((ele) =>
          leavePermissions?.every((el) => ele.name !== el.name)
          );
          setLeaveManagementData([
            ...leavePermissions,
            ...leavePermissionsFilter
          ]);
        }

        //Work model
        if (WorkModelTabData[0]?.permissions.length > 0) {
          const workModelPermissions = WorkModelTabData[0]?.permissions;
          const workModelPermissionsFilter = workModelData?.filter((ele) =>
            workModelPermissions?.every((el) => ele.name !== el.name)
          );
          setWorkModelData([
            ...workModelPermissions,
            ...workModelPermissionsFilter
          ]);
        }

        //Timesheet
        if (timesheetTabData[0]?.permissions.length > 0) {
          const timesheetPermissions = timesheetTabData[0]?.permissions;
          const timesheetPermissionsFilter = timesheetData?.filter((ele) =>
            timesheetPermissions?.every((el) => ele.name !== el.name)
          );
          setTimesheetData([
            ...timesheetPermissions,
            ...timesheetPermissionsFilter
          ]);
        }
        
        //Task Assignment
        if (taskAssignmentTabData[0]?.permissions.length > 0) {
          const taskAssignmentPermissions = taskAssignmentTabData[0]?.permissions;
          const taskAssignmentPermissionsFilter = taskAssignmentData?.filter((ele) =>
            taskAssignmentPermissions?.every((el) => ele.name !== el.name)
          );
          setTaskAssignmentData([
            ...taskAssignmentPermissions,
            ...taskAssignmentPermissionsFilter
          ]);
        }

        //Time Entry
        if (timeEntryTabData[0]?.permissions.length > 0) {
          const timeEntryPermissions = timeEntryTabData[0]?.permissions;
          const timeEntryPermissionsFilter = timeEntryData?.filter((ele) =>
            timeEntryPermissions?.every((el) => ele.name !== el.name)
          );
          setTimeEntryData([
            ...timeEntryPermissions,
            ...timeEntryPermissionsFilter
          ]);
        }

        if (employeeTimesheetTabData[0]?.permissions.length > 0) {
          const employeeTimesheetPermissions = employeeTimesheetTabData[0]?.permissions;
          const employeeTimesheetPermissionsFilter = timesheetData?.filter((ele) =>
            employeeTimesheetPermissions?.every((el) => ele.name !== el.name)
          );
          setTimesheetData([
            ...employeeTimesheetPermissions,
            ...employeeTimesheetPermissionsFilter
          ]);
        }

        //Detailed Report
        if (detailReportTabData[0]?.permissions.length > 0) {
          const detailReportPermissions = detailReportTabData[0]?.permissions;
          const detailReportPermissionsFilter = detailReportData?.filter((ele) =>
            detailReportPermissions?.every((el) => ele.name !== el.name)
          );
          setDetailReportData([
            ...detailReportPermissions,
            ...detailReportPermissionsFilter
          ]);
        }

        //Summarized Report
        if (summarizedReportTabData[0]?.permissions.length > 0) {
          const summarizedReportPermissions = summarizedReportTabData[0]?.permissions;
          const summarizedReportPermissionsFilter = summarizedReportData?.filter((ele) =>
            summarizedReportPermissions?.every((el) => ele.name !== el.name)
          );
          setSummarizedReportData([
            ...summarizedReportPermissions,
            ...summarizedReportPermissionsFilter
          ]);
        }

        //Task Based Report
        if (taskBasedReportTabData[0]?.permissions.length > 0) {
          const taskBasedReportPermissions = taskBasedReportTabData[0]?.permissions;
          const taskBasedReportPermissionsFilter = taskBasedReportData?.filter((ele) =>
            taskBasedReportPermissions?.every((el) => ele.name !== el.name)
          );
          setTaskBasedReportData([
            ...taskBasedReportPermissions,
            ...taskBasedReportPermissionsFilter
          ]);
        }

        //Variance Report
        if (varianceReport && varianceReport.length > 0) {
          const varianceReportPermissions = varianceReportTabData[0]?.permissions || [];
          const varianceReportFilter = varianceReport?.filter((ele) =>
            varianceReportPermissions?.every((el) => ele.name !== el.name)
          );
          othersTabData = [
            ...othersTabData,
            ...varianceReportPermissions,
            ...varianceReportFilter
          ];
          setVarianceReport([...varianceReportPermissions, ...varianceReportFilter]);
        }

        //Work from home
        if (WorkFromHomeTabData[0]?.permissions.length > 0) {
          const workFromHomePermissions = WorkFromHomeTabData[0]?.permissions;
          const workFromHomePermissionsFilter = workFromHomeData?.filter((ele) =>
            workFromHomePermissions?.every((el) => ele.name !== el.name)
          );
          setWorkFromHomeData([
            ...workFromHomePermissions,
            ...workFromHomePermissionsFilter
          ]);
        }

        //Resource Pool
        if (resourcePoolTabData[0]?.permissions.length > 0) {
          const resourcePoolPermissions = resourcePoolTabData[0]?.permissions;
          const resourcePoolPermissionsFilter = resourcePoolData?.filter((ele) =>
            resourcePoolPermissions?.every((el) => ele.name !== el.name)
          );
          setResourcePoolData([
            ...resourcePoolPermissions,
            ...resourcePoolPermissionsFilter
          ]);
        }

        //year plan
      if (yearPlanData && yearPlanData.length > 0) {
        const yearPlanPermissions = yearPlanTabData[0]?.permissions || [];
        const yearPlanFilter = yearPlanData?.filter((ele) =>
        yearPlanPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...yearPlanPermissions,
          ...yearPlanFilter
        ];
        setYearPlanData([...yearPlanPermissions, ...yearPlanFilter]);
      }

      //carry forwarded leaves
      if (carryForwardedLeavesData && carryForwardedLeavesData.length > 0) {
        const carryForwardedLeavesPermissions = carryForwardedLeavesTabData[0]?.permissions || [];
        const carryForwardedLeavesFilter = carryForwardedLeavesData?.filter((ele) =>
        carryForwardedLeavesPermissions?.every((el) => ele.name !== el.name)
        );
        othersTabData = [
          ...othersTabData,
          ...carryForwardedLeavesPermissions,
          ...carryForwardedLeavesFilter
        ];
        setCarryForwardedLeavesData([...carryForwardedLeavesPermissions, ...carryForwardedLeavesFilter]);
      }
        
      const filteredEditOthers = othersTabData.filter(
        (oth) =>
          !isAttendancePermission(oth) &&
          (oth.name === 'Edit Skills' ||
            oth.name === 'Edit Resources' ||
            oth.name === 'Edit Segments' ||
            oth.name === 'Edit Configurations' ||
            oth.name === 'Edit Customer' ||
            oth.name === 'Edit Stakeholder' ||
            oth.name === 'Edit Define Leaves' ||
            oth.name === 'Edit Year Plan' ||
            oth.name === 'Edit Carry Forwarded Leaves')
      );

      const filteredViewOthers = othersTabData.filter(
        (oth) =>
          !isAttendancePermission(oth) &&
          oth.name !== 'Edit Skills' &&
          oth.name !== 'Edit Resources' &&
          oth.name !== 'Edit Segments' &&
          oth.name !== 'Edit Configurations' &&
          oth.name !== 'Edit Customer' &&
          oth.name !== 'Edit Stakeholder' &&
          oth.name !== 'Edit Define Leaves' &&
          oth.name !== 'Edit Year Plan' &&
          oth.name !== 'Edit Carry Forwarded Leaves'
      );

      setOthers(filteredViewOthers);
      setOthersEdit(filteredEditOthers);

      // Project
      if (projectTabData[0]?.fields.length > 0) {
        const projectFields = projectTabData[0]?.fields;

        const generalDetailsProjectFilter = generalDetailsProject?.filter(
          (ele) => projectFields?.every((el) => ele.name !== el.name)
        );
        setgeneralDetailsProject([
          ...projectFields?.filter((el) => el.category === 'General'),
          ...generalDetailsProjectFilter
        ]);
        const FinancialDetailsFilter = FinancialDetails?.filter((ele) =>
          projectFields?.every((el) => ele.name !== el.name)
        );
        setFinancialDetails([
          ...projectFields?.filter((el) => el.category === 'Financial'),
          ...FinancialDetailsFilter
        ]);
        const TimeEstimationsFilter = timeEstimations?.filter((ele) =>
          projectFields?.every((el) => ele.name !== el.name)
        );
        setTimeEstimations([
          ...projectFields?.filter((el) => el.category === 'Time Estimation'),
          ...TimeEstimationsFilter
        ]);
        const stakeholdersFilter = stakeholders?.filter((ele) =>
          projectFields?.every((el) => ele.name !== el.name)
        );

        setStakeholders([
          ...projectFields?.filter((el) => el.category === 'Stakeholders'),
          ...stakeholdersFilter
        ]);
      }
      // Project permissions
      if (projectTabData[0]?.permissions.length > 0) {
        const projectPermissions = projectTabData[0]?.permissions;
        const employeePermissionsProjectFilter =
          commonPermissionsProject?.filter((ele) =>
            projectPermissions?.every((el) => ele.name !== el.name)
          );
        setcommonPermissionsProject([
          ...projectPermissions,
          ...employeePermissionsProjectFilter
        ]);
      }
    }
  }, [roleById]);

  const onClickAll = (array: any, type: string, setArray: any, e?: any) => {
    let changedArray;
    if (array?.length > 0 && type === 'status') {
      changedArray = array.map((arr) => {
        return {
          category: arr.category,
          edit: arr.edit,
          id: arr.id,
          name: arr.name,
          tab: arr.tab,
          view:
            arr.name === 'Name' || arr.name === 'Name in Jira' || arr.name === 'Gender'
              ? true
              : e.target.checked
        };
      });
    }
    if (array?.length > 0 && type === 'common') {
      changedArray = array.map((arr) => {
        return {
          id: arr.id,
          name: arr.name,
          tab: arr.tab,
          value: e.target.checked
        };
      });
    }
    if (array?.length > 0 && type === 'edit') {
      changedArray = array.map((arr) => {
        return {
          category: arr.category,
          edit:
            arr.edit === undefined
              ? undefined
              : e === false
              ? e
              : e.target.checked,
          id: arr.id,
          name: arr.name,
          tab: arr.tab,
          view: arr.view
        };
      });
    }

    setArray(changedArray);
  };

  const onSubmit = (data) => {
    const allFieldsArray = [
      ...dashboardData.map((ele) => {
        return {
          name: ele.name,
          category: ele.category,
          edit: ele.edit,
          view: ele.view,
          tab: 'Dashboard'
        };
      }),
      ...generalDetails.map((ele) => {
        return {
          name: ele.name,
          category: ele.category,
          edit: ele.edit,
          view: ele.view,
          tab: 'Employee'
        };
      }),
      ...contactDetails.map((ele) => {
        return {
          name: ele.name,
          category: ele.category,
          edit: ele.edit,
          view: ele.view,
          tab: 'Employee'
        };
      }),
      ...bankingDetails.map((ele) => {
        return {
          name: ele.name,
          category: ele.category,
          edit: ele.edit,
          view: ele.view,
          tab: 'Employee'
        };
      }),
      ...employementDetails.map((ele) => {
        return {
          name: ele.name,
          category: ele.category,
          edit: ele.edit,
          view: ele.view,
          tab: 'Employee'
        };
      }),
      ...generalDetailsProject.map((ele) => {
        return {
          name: ele.name,
          category: ele.category,
          edit: ele.edit,
          view: ele.view,
          tab: 'Project'
        };
      }),
      ...FinancialDetails.map((ele) => {
        return {
          name: ele.name,
          category: ele.category,
          edit: ele.edit,
          view: ele.view,
          tab: 'Project'
        };
      }),
      ...timeEstimations.map((ele) => {
        return {
          name: ele.name,
          category: ele.category,
          edit: ele.edit,
          view: ele.view,
          tab: 'Project'
        };
      }),
      ...stakeholders.map((ele) => {
        return {
          name: ele.name,
          category: ele.category,
          edit: ele.edit,
          view: ele.view,
          tab: 'Project'
        };
      })
    ];

    const allPermissionsArray = [
      ...commonPermissions.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Employee' };
      }),
      ...commonPermissionsProject.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Project' };
      }),
      ...leaveManagementData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Leave Management' };
      }),
      ...workModelData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Work Model' };
      }),
      ...timesheetData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Activity Management' };
      }),
      ...taskAssignmentData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Task Assignment' };
      }),
      ...timeEntryData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Time Entry' };
      }),
      ...detailReportData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Detailed Report' };
      }),
      ...employeeTimesheetData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Employee Timesheet' };
      }),
      ...summarizedReportData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Summarized Report' };
      }),
      ...taskBasedReportData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Task Based Report' };
      }),
      ...varianceReport.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Variance Report' };
      }),
      ...feedbackData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Feedback' };
      }),
      ...eventManagementData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Event Management' };
      }),
      ...employeeOnboardingData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Employee Onboarding' };
      }),
      ...onboardingToDoListData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Onboarding To Do List' };
      }),
      ...attendanceData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Attendance' };
      }),
      ...workFromHomeData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Work From Home' };
      }),
      ...resourcePoolData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Resource Pool' };
      }),
       ...designationData.map((comm) => {
        return { name: comm.name, value: comm.value, tab: 'Designations' };
      }),
      ...others.filter((comm) => !isAttendancePermission(comm)).map((comm) => {
        if (comm.name === 'View Project Health Summary') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Project Health Summary'
          };
        } else if (comm.name === 'View Resources') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Resource Management'
          };
        } else if (comm.name === 'View Skills') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Skills'
          };
        } else if (comm.name === 'View Segments') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Segments'
          };
        } else if (comm.name === 'View Customer') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Customer'
          };
        } else if (comm.name === 'View Stakeholder') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Stakeholder'
          };
        } else if (comm.name === 'View Configurations') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Configurations'
          }; 
        } 
        else if (comm.name === 'View Define Leaves') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Define Leaves'
          }; 
        }else if (comm.name === 'View Year Plan') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Year Plan'
          };
        }else if (comm.name === 'View Carry Forwarded Leaves') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Carry Forwarded Leaves'
          };
        } 
        else {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Configurations'
          };
        }
      }),

      ...othersEdit.filter((comm) => !isAttendancePermission(comm)).map((comm) => {
        if (comm.name === 'Edit Resources') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Resource Management'
          };
        } else if (comm.name === 'Edit Skills') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Skills'
          };
        } else if (comm.name === 'Edit Segments') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Segments'
          };
        } else if (comm.name === 'Edit Customer') {
          //new name is client, but permission is Customer
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Customer'
          };
        } else if (comm.name === 'Edit Stakeholder') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Stakeholder'
          };
        } else if (comm.name === 'Edit Configurations') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Configurations'
          };
        } 
        else if (comm.name === 'Edit Define Leaves') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Define Leaves'
          };
        }else if (comm.name === 'Edit Year Plan') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Year Plan'
          };
        }else if (comm.name === 'Edit Carry Forwarded Leaves') {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Carry Forwarded Leaves'
          };
        }
         else {
          return {
            name: comm.name,
            value: comm.value,
            tab: 'Configurations'
          };
        }
      })
    ];

    const fieldsFilterArray = allFieldsArray.filter(
      (obj) => obj.view || obj.edit
    );

    if (Date.parse(data.startDate) > Date.parse(data.endDate)) {
      setDateError('End date should be greater than start date');
    } else {
      const body = {
        id: roleById.id,
        name: data.roleName,
        startDate: data.startDate,
        endDate:
          data.endDate !== '' && data.endDate !== 'Invalid date'
            ? data.endDate
            : null,
        fieldRequests: [...fieldsFilterArray],
        permissionRequests: [...allPermissionsArray]
      };
      dispatch(AppActions.showLoader());
      updateRole(body)
        .then((res) => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'You’ve updated the user role successfully.',
              severity: 'success'
            })
          );
          getData();
          handleClose();
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'Unable to update the user role',
              severity: 'error'
            })
          );
          dispatch(AppActions.hideLoader());
        });
    }
  };

  const deleteById = (id) => {
    deleteRole(id).then((res) => {
      dispatch(
        AppActions.toggleSnackBarOpen({
          message: 'You’ve delete the user role successfully.',
          severity: 'success'
        })
      );
      getData();
      handleClose();
    });
  };

  const [role, setrole] = useState('');
  
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid
        item
        xs={12}
        md={12}
        sx={{ pt: 3, pb: 2, pl: 2, display: 'flex', justifyContent: 'between' }}
      >
        <Typography style={{ fontSize: '15px' }} variant="h3">
          {visibility && isEdit ? 'View Role' : 'Edit Role'}
        </Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Role Name
          </Typography>
          <TextField
            disabled={isEdit}
            size="small"
            {...register('roleName', {
              required: true,
              maxLength: 30
            })}
            // value={roleById.name}
            error={!!errors['roleName']}
            helperText={errors['roleName'] ? errors['roleName'].message : ''}
            style={TextFieldStyle}
            fullWidth
            placeholder="Enter Role Name"
            variant="outlined"
            onChange={(e) => {
              setrole(e.target.value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Start Date
          </Typography>
          <div style={{ marginLeft: 13, marginRight: 13 }}>
            <FormControl fullWidth>
              <DatePicker
                disabled={isEdit}
                InputProps={{
                  className: 'date-picker'
                }}
                renderInput={(params) => (
                  <TextField {...params} id="startDate" />
                )}
                value={startDate ? startDate : roleById?.startDate ? roleById.startDate : ''}
                onChange={(newValue) => {
                  if (newValue) {
                    setStartDate(moment(newValue).format('YYYY-MM-DD'));
                    setValue(
                      'startDate',
                      moment(newValue).format('YYYY-MM-DD')
                    );
                    setIsStartDateError(false);
                  } else {
                    setIsStartDateError(true);
                  }
                }}
              />
            </FormControl>
            {errors['startDate'] && (
              <>
                {isStartDateError && (
                  <>
                    <div style={{ fontSize: '12px', color: 'red' }}>
                      {'Start Date is required'}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            End Date
          </Typography>
          <div style={{ marginLeft: 15, marginRight: 13 }}>
            <FormControl fullWidth>
              <DatePicker
                disabled={isEdit}
                InputProps={{
                  className: 'date-picker'
                }}
                minDate={new Date(startDate ? startDate : roleById?.startDate)}
                renderInput={(params) => <TextField {...params} id="endDate" />}
                value={endDate ? endDate : roleById?.endDate ? roleById.endDate : ''}
                onChange={(newValue) => {
                  if (newValue) {
                    setEndDate(moment(newValue).format('YYYY-MM-DD'));
                    setValue('endDate', moment(newValue).format('YYYY-MM-DD'));
                  }
                }}
              />
            </FormControl>
            {dateError && (
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {dateError}&nbsp;
            </Typography>
          )}
          </div>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ pl: 2, pt: 2, pb: 2 }} variant="h4">
            Permissions
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Box sx={{ pl: 4, pr: 2, pt: 2, pb: 2, width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={tabvalue}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
              variant="scrollable"
            >
              <Tab
                id="dash-tab-edit"
                style={{ fontSize: '12px' }}
                value="one"
                label="Dashboard"
              />
              <Tab
                id="emp-tab-edit"
                style={{ fontSize: '12px' }}
                value="two"
                label="Employees"
              />
              <Tab
                id="projects-tab-edit"
                style={{ fontSize: '12px' }}
                value="three"
                label="Projects"
              />
              <Tab
                id="leave-tab-edit"
                style={{ fontSize: '12px' }}
                value="five"
                label="Leave Management"
              />
              <Tab
                id="resource-pool-tab-edit"
                style={{ fontSize: '12px' }}
                value="six"
                label="Resource Management"
              />
              <Tab
                id="timesheet-tab-edit"
                style={{ fontSize: '12px' }}
                value="ten"
                label="Timesheet"
              />
               <Tab
                id="designation-tab-edit"
                style={{ fontSize: '12px' }}
                value="thirteen"
                label="Designations"
              />
              <Tab
                id="feedback"
                style={{ fontSize: '12px' }}
                value="eleven"
                label="Feedback"
              />
              <Tab
                id="event-management"
                style={{ fontSize: '12px' }}
                value="twelve"
                label="Event Management"
              />
              <Tab
                id="employee-onboarding-tab"
                style={{ fontSize: '12px' }}
                value="fourteen"
                label="Employee Onboarding"
              />
              <Tab
                id="attendance-tab-edit"
                style={{ fontSize: '12px' }}
                value="fifteen"
                label="Attendance"
              />
              <Tab
                id="others-tab-edit"
                style={{ fontSize: '12px' }}
                value="four"
                label="Others"
              />
            </Tabs>
          </Box>
          {tabvalue === 'one' && (
            <TabOne
              dashboardData={dashboardData}
              setdashboardData={setdashboardData}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
          )}
          {tabvalue === 'two' && (
            <TabTwo
              commonPermissions={commonPermissions}
              setcommonPermissions={setcommonPermissions}
              generalDetails={generalDetails}
              setgeneralDetails={setgeneralDetails}
              employementDetails={employementDetails}
              setEmployementDetails={setEmployementDetails}
              bankingDetails={bankingDetails}
              setBankingDetails={setBankingDetails}
              contactDetails={contactDetails}
              setcontactDetails={setcontactDetails}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
          )}
          {tabvalue === 'three' && (
            <TabThree
              commonPermissionsProject={commonPermissionsProject}
              setcommonPermissionsProject={setcommonPermissionsProject}
              generalDetailsProject={generalDetailsProject}
              setgeneralDetailsProject={setgeneralDetailsProject}
              timeEstimations={timeEstimations}
              setTimeEstimations={setTimeEstimations}
              stakeholders={stakeholders}
              setStakeholders={setStakeholders}
              financialDetails={FinancialDetails}
              setFinancialDetails={setFinancialDetails}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
          )}
          {tabvalue === 'five' && (
            <TabFive
              leaveManagementData={leaveManagementData}
              setLeaveManagementData={setLeaveManagementData}
              workModelData={workModelData}
              setWorkModelData={setWorkModelData}
              workFromHomeData={workFromHomeData}
              setWorkFromHomeData={setWorkFromHomeData}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
          )}
          {tabvalue === 'four' && (
            <TabFour
              setOthers={setOthers}
              setOthersEdit={setOthersEdit}
              others={others}
              othersEdit={othersEdit}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
          )}
          {tabvalue === 'six' && (
            <TabNine
              setOthers={setResourcePoolData}
              others={resourcePoolData}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
          )}
            {tabvalue === 'ten' && (
            <TabTen
              timesheetData={timesheetData}
              setTimesheetData={setTimesheetData}
              taskAssignmentData={taskAssignmentData}
              setTaskAssignmentData={setTaskAssignmentData}
              timeEntryData={timeEntryData}
              setTimeEntryData={setTimeEntryData}
              EmployeTimesheetData={employeeTimesheetData}
              setEmployeeTimesheetData={setEmployeeTimesheetData}
              detailReportData={detailReportData}
              setDetailReportData={setDetailReportData}
              summarizedReportData={summarizedReportData}
              setSummarizedReportData={setSummarizedReportData}
              taskBasedReportData={taskBasedReportData}
              setTaskBasedReportData={setTaskBasedReportData}
              varianceReportData={varianceReport}
              setVarianceReportData={setVarianceReport}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
            )}

            {tabvalue === 'eleven' && (
            <TabEleven
              setOthers={setFeedbackData}
              others={feedbackData}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
          )}

          {tabvalue === 'twelve' && (
            <TabTwelve
              setOthers={setEventManagementData}
              others={eventManagementData}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
          )}
          
          {tabvalue === 'thirteen' && (
            <TabThirteen
              setDesignations={setDesignationData}
              designations={designationData}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
          )}

          {tabvalue === 'fourteen' && (
            <TabFourteen
              setEmployeeOnboardingData={setEmployeeOnboardingData}
              employeeOnboardingData={employeeOnboardingData}
              onboardingToDoListData={onboardingToDoListData}
              setOnboardingToDoListData={setOnboardingToDoListData}
              onClickAll={onClickAll}
              isEdit={isEdit}
            />
          )}
          {tabvalue === 'fifteen' && (
            <TabFifteen
              attendanceData={attendanceData}
              setAttendanceData={setAttendanceData}
              isEdit={isEdit}
            />
          )}
        </Box>
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid container spacing={2} sx={{ pl: 2 }}>
        <Grid item display={'inline-flex'} xs={6}>
          <Typography
            style={{ display: 'flex', alignItems: 'center' }}
            variant="body2"
          >
            Legends:
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '0.5rem'
              }}
            >
              <BuildIcon
                color="primary"
                sx={{ fontSize: '0.8rem', mr: '0.2rem' }}
              />
              <Typography variant="body2">Edit Access</Typography>
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}
          xs={6}
        >
          <Button
            sx={{
              width: '30%',
              ml: 3,
              fontSize: '13px',
              fontWeight: 'normal'
            }}
            variant="outlined"
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>

          {!isEdit && (
            <Button
              disabled={role === ''}
              type="submit"
              sx={{
                width: '30%',
                ml: 3,
                fontSize: '13px',
                fontWeight: 'normal',
                background: '#0069E4'
              }}
              variant="contained"
            >
              Update
            </Button>
          )}
        </Grid>
      </Grid>
      <ConfirmationModal
        isLoading={isLoading}
        open={deleteOpen}
        toggle={toggleDelete}
        message={`Are you sure you want to delete this role?`}
        onConfirm={() => deleteById(roleById.id)}
        noToggle={toggleDelete}
      />
    </form>
  );
};

export default EditForm;